function close(extension) {
  if (extension) {
    extension.close();
  }
}

function Footer({
  extension,
  selectedForm,
  onCreateNewForm,
  onSaveForm,
  onSubmitForm,
}) {
  const mode = extension?.params?.mode || 'viewer';
  return (
    <div className="footer col-sm-12">
      <div className="btn-group" role="group">
        {selectedForm ? (
          mode === 'builder' ? (
            <button className="btn btn-primary btn-md" onClick={onSaveForm}>
              Save Form
            </button>
          ) : (
            <button
              className="btn btn-primary btn-md"
              onClick={() => onSubmitForm(selectedForm.submission)}
            >
              Submit Form
            </button>
          )
        ) : mode === 'builder' ? (
          <button className="btn btn-primary btn-md" onClick={onCreateNewForm}>
            Create New Form
          </button>
        ) : null}
        <button
          className="btn btn-outline-primary btn-md"
          onClick={() => close(extension)}
        >
          Close
        </button>
      </div>
    </div>
  );
}
export default Footer;
